import { render } from "./VIPFooter.vue?vue&type=template&id=ce6bda8a&scoped=true"
import script from "./VIPFooter.vue?vue&type=script&lang=js"
export * from "./VIPFooter.vue?vue&type=script&lang=js"

import "./VIPFooter.vue?vue&type=style&index=0&id=ce6bda8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce6bda8a"]])

export default __exports__